"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // #FFFFFF

var colorWhite = exports.colorWhite = "rgba(255, 255, 255, 1)"; // #F7F9FA

var colorGray50 = exports.colorGray50 = "rgba(247, 249, 250, 1)"; // #EFF2F5

var colorGray100 = exports.colorGray100 = "rgba(239, 242, 245, 1)"; // #DFE3E8

var colorGray200 = exports.colorGray200 = "rgba(223, 227, 232, 1)"; // #CED2D6

var colorGray300 = exports.colorGray300 = "rgba(206, 210, 214, 1)"; // #B5B9BD

var colorGray400 = exports.colorGray400 = "rgba(181, 185, 189, 1)"; // #9A9DA1

var colorGray500 = exports.colorGray500 = "rgba(154, 157, 161, 1)"; // #828487

var colorGray600 = exports.colorGray600 = "rgba(130, 132, 135, 1)"; // #616365

var colorGray700 = exports.colorGray700 = "rgba(97, 99, 101, 1)"; // #4D4F51

var colorGray800 = exports.colorGray800 = "rgba(77, 79, 81, 1)"; // #383B3D

var colorGray900 = exports.colorGray900 = "rgba(56, 59, 61, 1)"; // #131517

var colorGray1000 = exports.colorGray1000 = "rgba(19, 21, 23, 1)"; // #165CAB

var colorPrimaryBrand = exports.colorPrimaryBrand = "rgba(22, 92, 171, 1)"; // #044187

var colorPrimaryMedium = exports.colorPrimaryMedium = "rgba(4, 65, 135, 1)"; // #07305C

var colorPrimaryDark = exports.colorPrimaryDark = "rgba(7, 48, 92, 1)"; // #1F76D8

var colorPrimarySelection = exports.colorPrimarySelection = "rgba(31, 118, 216, 1)"; // #1F76D8, Opacity .7

var colorPrimarySelectionA70 = exports.colorPrimarySelectionA70 = "rgba(31, 118, 216, .7)"; // #1F76D8, Opacity .5

var colorPrimarySelectionA50 = exports.colorPrimarySelectionA50 = "rgba(31, 118, 216, .5)"; // #C2E5FF

var colorPrimaryHover = exports.colorPrimaryHover = "rgba(194, 229, 255, 1)"; // #C2E5FF, Opacity .5

var colorPrimaryHoverA50 = exports.colorPrimaryHoverA50 = "rgba(194, 229, 255, .5)"; // #E0F2FF

var colorPrimaryHoverLight = exports.colorPrimaryHoverLight = "rgba(224, 242, 255, 1)"; // #0095FF

var colorPrimaryFocus = exports.colorPrimaryFocus = "rgba(0, 149, 255, 1)"; // #EBFCF7

var colorSuccess50 = exports.colorSuccess50 = "rgba(235, 252, 247, 1)"; // #CBF5E8

var colorSuccess100 = exports.colorSuccess100 = "rgba(203, 245, 232, 1)"; // #ADE0D0

var colorSuccess200 = exports.colorSuccess200 = "rgba(173, 224, 208, 1)"; // #7CCFB4

var colorSuccess300 = exports.colorSuccess300 = "rgba(124, 207, 179, 1)"; // #56ba9a

var colorSuccess400 = exports.colorSuccess400 = "rgba(86, 186, 154, 1)"; // #2FA882

var colorSuccess500 = exports.colorSuccess500 = "rgba(47, 168, 130, 1)"; // #1E8F6B

var colorSuccess600 = exports.colorSuccess600 = "rgba(30, 143, 107, 1)"; // #147556

var colorSuccess700 = exports.colorSuccess700 = "rgba(20, 117, 86, 1)"; // #0C573F

var colorSuccess800 = exports.colorSuccess800 = "rgba(12, 87, 63, 1)"; // #033827

var colorSuccess900 = exports.colorSuccess900 = "rgba(3, 56, 39, 1)"; // #002418

var colorSuccess1000 = exports.colorSuccess1000 = "rgba(0, 36, 24, 1)"; // #F0F7FF

var colorInfo50 = exports.colorInfo50 = "rgba(240, 247, 255, 1)"; // #D9EBFF

var colorInfo100 = exports.colorInfo100 = "rgba(217, 235, 255, 1)"; // #B4D6FA

var colorInfo200 = exports.colorInfo200 = "rgba(180, 214, 250, 1)"; // #91C0F2

var colorInfo300 = exports.colorInfo300 = "rgba(145, 192, 242, 1)"; // #75AEEB

var colorInfo400 = exports.colorInfo400 = "rgba(117, 174, 235, 1)"; // #5B98D9

var colorInfo500 = exports.colorInfo500 = "rgba(91, 152, 217, 1)"; // #4781BF

var colorInfo600 = exports.colorInfo600 = "rgba(71, 129, 191, 1)"; // #2E6299

var colorInfo700 = exports.colorInfo700 = "rgba(46, 98, 153, 1)"; // #1D4673

var colorInfo800 = exports.colorInfo800 = "rgba(29, 70, 115, 1)"; // #0F2D4D

var colorInfo900 = exports.colorInfo900 = "rgba(15, 45, 77, 1)"; // #001933

var colorInfo1000 = exports.colorInfo1000 = "rgba(0, 25, 51, 1)"; // #FFECE8

var colorError50 = exports.colorError50 = "rgba(255, 236, 232, 1)"; // #FFDAD1

var colorError100 = exports.colorError100 = "rgba(255, 218, 209, 1)"; // #FABDAF

var colorError200 = exports.colorError200 = "rgba(250, 189, 175, 1)"; // #F59D89

var colorError300 = exports.colorError300 = "rgba(245, 157, 137, 1)"; // #E87E66

var colorError400 = exports.colorError400 = "rgba(232, 126, 102, 1)"; // #E0694F

var colorError500 = exports.colorError500 = "rgba(224, 105, 79, 1)"; // #D15336

var colorError600 = exports.colorError600 = "rgba(209, 83, 54, 1)"; // #B23E24

var colorError700 = exports.colorError700 = "rgba(178, 62, 36, 1)"; // #942A12

var colorError800 = exports.colorError800 = "rgba(148, 42, 18, 1)"; // #6B1C0B

var colorError900 = exports.colorError900 = "rgba(107, 28, 11, 1)"; // #4C0E00

var colorError1000 = exports.colorError1000 = "rgba(76, 14, 0, 1)"; // #F5EBFA

var colorInProgress50 = exports.colorInProgress50 = "rgba(245, 235, 250, 1)"; // #ECD7F5

var colorInProgress100 = exports.colorInProgress100 = "rgba(236, 215, 245, 1)"; // #E5C7F2

var colorInProgress200 = exports.colorInProgress200 = "rgba(229, 199, 242, 1)"; // #CDABDB

var colorInProgress300 = exports.colorInProgress300 = "rgba(205, 171, 219, 1)"; // #B38FC2

var colorInProgress400 = exports.colorInProgress400 = "rgba(179, 143, 194, 1)"; // #A07BB0

var colorInProgress500 = exports.colorInProgress500 = "rgba(160, 123, 176, 1)"; // #885F99

var colorInProgress600 = exports.colorInProgress600 = "rgba(136, 95, 153, 1)"; // #6B477A

var colorInProgress700 = exports.colorInProgress700 = "rgba(107, 71, 122, 1)"; // #543461

var colorInProgress800 = exports.colorInProgress800 = "rgba(84, 52, 97, 1)"; // #3B2445

var colorInProgress900 = exports.colorInProgress900 = "rgba(59, 36, 69, 1)"; // #231429

var colorInProgress1000 = exports.colorInProgress1000 = "rgba(35, 20, 41, 1)"; // #FFEEDB

var colorWarning50 = exports.colorWarning50 = "rgba(255, 238, 219, 1)"; // #FFE0BD

var colorWarning100 = exports.colorWarning100 = "rgba(255, 224, 189, 1)"; // #FFCF99

var colorWarning200 = exports.colorWarning200 = "rgba(255, 207, 153, 1)"; // #FABD78

var colorWarning300 = exports.colorWarning300 = "rgba(250, 189, 120, 1)"; // #F0AB5D

var colorWarning400 = exports.colorWarning400 = "rgba(240, 171, 93, 1)"; // #E59539

var colorWarning500 = exports.colorWarning500 = "rgba(229, 149, 57, 1)"; // #DB831F

var colorWarning600 = exports.colorWarning600 = "rgba(219, 131, 31, 1)"; // #C77110

var colorWarning700 = exports.colorWarning700 = "rgba(199, 113, 16, 1)"; // #B06209

var colorWarning800 = exports.colorWarning800 = "rgba(176, 98, 9, 1)"; // #995303

var colorWarning900 = exports.colorWarning900 = "rgba(153, 83, 3, 1)"; // #703C00

var colorWarning1000 = exports.colorWarning1000 = "rgba(112, 60, 0, 1)"; // #4781BF

var colorViz1 = exports.colorViz1 = "rgba(71, 129, 191, 1)"; // #A1BBE5

var colorViz2 = exports.colorViz2 = "rgba(161, 187, 229, 1)"; // #E59539

var colorViz3 = exports.colorViz3 = "rgba(229, 149, 57, 1)"; // #E8CE8B

var colorViz4 = exports.colorViz4 = "rgba(232, 206, 139, 1)"; // #6F5DA8

var colorViz5 = exports.colorViz5 = "rgba(111, 93, 168, 1)"; // #CDABDB

var colorViz6 = exports.colorViz6 = "rgba(205, 171, 219, 1)"; // #3D9990

var colorViz7 = exports.colorViz7 = "rgba(61, 153, 144, 1)"; // #7CCFB4

var colorViz8 = exports.colorViz8 = "rgba(124, 207, 180, 1)"; // #4C5FB5

var colorViz9 = exports.colorViz9 = "rgba(76, 95, 181, 1)"; // #979ACC

var colorViz10 = exports.colorViz10 = "rgba(151, 154, 204, 1)"; // #CC5E69

var colorViz11 = exports.colorViz11 = "rgba(204, 94, 105, 1)"; // #EDA19F

var colorViz12 = exports.colorViz12 = "rgba(237, 161, 159, 1)"; // #4692B0

var colorViz13 = exports.colorViz13 = "rgba(70, 146, 176, 1)"; // #8BD4D6

var colorViz14 = exports.colorViz14 = "rgba(139, 212, 214, 1)"; // #E0694F

var colorViz15 = exports.colorViz15 = "rgba(224, 105, 79, 1)"; // #F5A482

var colorViz16 = exports.colorViz16 = "rgba(245, 164, 130, 1)"; // #549970

var colorViz17 = exports.colorViz17 = "rgba(84, 153, 112, 1)"; // #9AD9A4

var colorViz18 = exports.colorViz18 = "rgba(154, 217, 164, 1)"; // #9C4174

var colorViz19 = exports.colorViz19 = "rgba(156, 65, 116, 1)"; // #CF7C92

var colorViz20 = exports.colorViz20 = "rgba(207, 124, 146, 1)";